import PremiumPageHeader from './PremiumPageHeader';
import ListViewSettings from './ListViewSettings';

export const LIST_FORM_SUBTITLE = 'Browse and manage records from this list view.';
export const LIST_FORM_SUBTITLE_WITH_SETTINGS =
    'Configure filters in General Settings. The table loads based on your saved preferences.';

function ListFormPageHeader({
    module,
    title,
    subtitle,
    viewKey,
    onSettingsSaved,
    headerActions,
    modeLabel = 'VIEW MODE',
}) {
    const resolvedSubtitle = subtitle || (
        viewKey && onSettingsSaved ? LIST_FORM_SUBTITLE_WITH_SETTINGS : LIST_FORM_SUBTITLE
    );

    const resolvedActions = headerActions || (
        viewKey && onSettingsSaved ? (
            <ListViewSettings viewKey={viewKey} onSaved={onSettingsSaved} />
        ) : null
    );

    return (
        <div className="container">
            <PremiumPageHeader
                module={module}
                title={title}
                subtitle={resolvedSubtitle}
                modeLabel={modeLabel}
                headerActions={resolvedActions}
            />
        </div>
    );
}

export default ListFormPageHeader;
